/**
 * BacklinksPanel.tsx - BacklinksPanel - Shows notes that link to the current note
 * 
 * CHANGE HISTORY:
 * - 251021_0421 [7529d5e] danielbeer: feat: migrate all packages to TypeScript structure
 */
import React from 'react';

const BacklinksPanel = ({ backlinks, onBacklinkClick, getField }) => {
  if (!backlinks || backlinks.length === 0) {
    return (
      <div className="backlinks-panel">
        <h4>Backlinks</h4>
        <p className="backlinks-empty">No backlinks yet</p>
      </div>
    );
  }
  
  return (
    <div className="backlinks-panel">
      <h4>Backlinks ({backlinks.length})</h4>
      <div className="backlinks-list">
        {backlinks.map(note => {
          const noteName = getField(note, 'name') || 'Untitled';
          const content = getField(note, 'content') || '';
          const preview = content.substring(0, 100);
          
          return (
            <div
              key={note.id}
              className="backlink-item"
              onClick={() => onBacklinkClick(note.id)}
            >
              <div className="backlink-name">{noteName}</div>
              <div className="backlink-preview">{preview}...</div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default BacklinksPanel;
